/** Etiquetas y estilos para filas del tablero del día (`SupervisorTodayItem`). */

export const SUPERVISOR_TODAY_STATUS_LABEL = {
  present: 'Presente',
  late: 'Tarde',
  absent: 'Ausente',
  incomplete: 'Incompleto',
  scheduled: 'Pendiente',
  no_shift: 'Sin turno',
};

export function supervisorTodayStatusBadgeClass(status) {
  if (status === 'absent') return 'danger';
  if (status === 'late' || status === 'incomplete') return 'warning';
  if (status === 'present') return 'success';
  if (status === 'scheduled') return 'scheduled';
  return '';
}
